import Vue from 'vue'
import teamsTransformer from './../../transformers/teams'
import store from './../../store'
import {includes, filter, sortBy, uniqBy} from 'lodash'

// When the request succeeds
const success = (teams) => {
  teams = uniqBy(teams, 'title')
  store.dispatch('getTeams', sortBy(teams, 'title'))
}

// When the request fails
const failed = () => {
}

export default (filters) => {
  let yearQueries = []
  if (filters.decade === 'all') { // All years
    filters.sport.forEach((sport) => {
      yearQueries = yearQueries.concat(getForSport(sport))
    })
  } else if (filters.year !== 0 && filters.decade === 0) { // Year
    yearQueries = yearQueries.concat(getForYear(filters.year))
  } else { // Decade
    for (let year = +filters.decade; year < (+filters.decade + 10); year++) {
      yearQueries = yearQueries.concat(getForYear(year))
    }
  }

  Vue.Promise.all(yearQueries)
    .then(responses => Vue.Promise.all(responses.map(response => response.json())))
    .then(function (jsons) {
      const teams = jsons.map(json => teamsTransformer.fetch(json)).flat()
      filterBySport(teams, filters)
    })
    .catch(failed)
}

const filterBySport = (teams, filters) => {
  const sports = filters.sport
  if (sports.length !== 0) {
    teams = filter(teams, (team) => {
      return includes(sports, team.sport)
    })
  }
  filterByGender(teams, filters)
}

const filterByGender = (teams, filters) => {
  const genders = filters.gender
  if (genders.length !== 0) {
    teams = filter(teams, (team) => {
      return includes(genders, team.gender)
    })
  }
  success(teams)
}

const getForYear = (year) => {
  return [
    Vue.http.get(`media/?collectionId=BC193DCB-C4F7-4BB8-AD1A7920A5DB583E&limit=1500&property_Team_Year=${year}`),
    Vue.http.get(`media/?collectionId=491A1043-BADE-4E0F-B95175D2C04AD5F6&limit=1500&property_Team_Year=${year}`),
  ]
}

const getForSport = (sport) => {
  return [
    Vue.http.get(`media/?collectionId=BC193DCB-C4F7-4BB8-AD1A7920A5DB583E&limit=1500&property_athletics=${sport}`),
    Vue.http.get(`media/?collectionId=491A1043-BADE-4E0F-B95175D2C04AD5F6&limit=1500&property_athletics=${sport}`),
  ]
}
